import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Table, Spin, Collapse, Card, Tag, message } from "antd";
import { BASE_URL } from "../Components/Constant";
import ApiService from "./apiService";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const { Title } = Typography;
const { Panel } = Collapse;

const ProcessingBatch = ({ recordData }) => {
    const [processes, setProcesses] = useState([]);
    const [inputLineItems, setInputLineItems] = useState([]);
    const [outputLineItems, setOutputLineItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchProcessData();
    }, []);

    const fetchProcessData = async () => {
        try {
            setLoading(true);
            const processService = new ApiService(`${BASE_URL}/fetch_records_parent_childs/Processing/Batch_id/${recordData?._id}`, {}, "GET");
            const processResponse = await processService.makeCall();
            setProcesses(processResponse);


        } catch (err) {
            const errorMessage = err && typeof err === 'object'
                ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to fetch due to unknown error';
            message.error(errorMessage);

        } finally {
            setLoading(false);
        }
    };



    return (
        <Spin spinning={loading} size="medium">
            <div style={{ width: "100%" }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                    <Col>
                        <Title level={3} style={{ marginTop: "10px" }}>Processed Batch Details</Title>
                    </Col>
                </Row>

                <Collapse>
                    {processes.map(process => (
                        <Panel
                            style={{ backgroundColor: process.ProccessingEndDateTime ? "#d4edda" : "white" }}
                            header={
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", color: process.ProccessingEndDateTime ? "green" : "black" }}>
                                    {process.Name}
                                    {process.ProccessingEndDateTime && <Tag color="green">Completed</Tag>}
                                </div>
                            }
                            key={process._id}>
                            <Card title="Processing Details" style={{ marginBottom: 10 }}>
                                <Row gutter={24}>
                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong> Name</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>
                                            {process?.Name ? (
                                                <Link to={`/record/Processing/${process._id}`}>{process.Name}</Link>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </Col>

                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Batch Name</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>
                                            {process?.Batch?.Name ? (
                                                <Link to={`/record/Batch/${process?.Batch._id}`}>{process.Batch?.Name}</Link>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </Col>

                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Quantity</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{process?.Quantity ? process?.Quantity : "0.00"} Metric Tons</div>
                                    </Col>

                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Finished Product</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{process?.FinishedProduct?.Name}</div>
                                    </Col>

                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Packaging Product</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{process?.PackagingProduct?.Name}</div>
                                    </Col>
                                </Row>

                                <Row gutter={16}>
                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Processing Start Date</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{process.ProcessingStartDate ? dayjs(process.ProcessingStartDate).format("DD/MM/YYYY hh:mm A") : ""}</div>
                                    </Col>

                                    <Col span={4} style={{ padding: "10px" }}>
                                        <Typography.Text style={{ fontSize: '18px' }} strong>Processing End Date</Typography.Text>
                                        <div style={{ fontSize: '15px' }}>{process.ProccessingEndDateTime ? dayjs(process.ProccessingEndDateTime).format("DD/MM/YYYY hh:mm A") : ""}</div>
                                    </Col>
                                </Row>


                            </Card>

                        </Panel>
                    ))}
                </Collapse>
            </div>
        </Spin>
    );
};

export default ProcessingBatch;
